import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "./index.scss";
import active_phone from "../../../svg/phone_solid.svg";
import userIcon from "../../../svg/user_solid.svg";
import emailIcon from "../../../svg/email_solid.svg";
import active_link from "../../../svg/active_link.svg";
import selectArrow from "../../../svg/select-arrow.svg";
import jwt_decode from "jwt-decode";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FetchProfileDetails,
  setUpProfile,
} from "../personalDetails/queries";
import {
  getOtherSpecialization,
  getProfileDetails,
} from "../../../store/apiCalls/profileDetails";
import { useSelector, useDispatch } from "react-redux";
import FeedbackFlow from "../Feedback";
import { isPublishable } from "../../../utils";
import UpArrowQuestion from "../../../components/UpArrowQuestion/UpArrowQuestion";
import {
  GET_OTHER_SUBJECT,
  SAVE_SUBJECT_STATUS,
} from "../../../store/actions/profileActions";
import BeforePublishModal from "../../../components/Modal/BeforePublishModal";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};

const PreviewProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const tokenFromStorage =
    localStorage.usertoken || localStorage.getItem("usertoken") || "";
  const decodedToken = tokenFromStorage ? jwt_decode(tokenFromStorage) : {};
  const id = decodedToken?.id || decodedToken?._id || "";

  const [showAccept, setShowAccept] = useState(false);
  const saveStatus = useSelector((state) => state?.ProfileReducer?.saveStatus);
  const reduxProfileUser = useSelector((state) => state?.ProfileReducer?.user);
  const [showFeedbackModal, setShowFeedbackModal] = useState(initialState);
  const [PreviewProfile, setPreviewProfile] = useState(
    location?.state?.profileDetails || {}
  );
  const [profile, setProfile] = useState("");
  const [error, setError] = useState({ apiErrors: "" });
  const navigate = useNavigate();
  const { user, userLoginDetails } = useSelector(
    (state) => state?.LoginReducer
  );
  const storedIMG = PreviewProfile?.profilePicture || "";
  const profilePic =
    PreviewProfile?.profilePicture ||
    PreviewProfile?.oldProfilePicture ||
    profile ||
    location?.state?.profileDetails?.profilePicture ||
    localStorage.getItem("user_profilePicture") ||
    "";

  const otherSubject = useSelector(
    (state) => state?.ProfileReducer?.otherSubject
  );

  useEffect(() => {
    setProfile(storedIMG);
  }, [storedIMG]);

  // Populate from location.state on mount (passed from PersonalDetails)
  useEffect(() => {
    if (location?.state?.profileDetails) {
      sucessHandler({ data: { data: location.state.profileDetails } });
    }
  }, []);

  const handleFeedback = (e) => {
    if (saveStatus) {
      setShowAccept(true);
    } else {
      e.preventDefault();
      setShowFeedbackModal({
        ...initialState,
        showFeedbackModal: !PreviewProfile.feedbackDone,
        congratsModal: PreviewProfile.feedbackDone,
      });
    }
  };

  const sucessHandler = (sucess) => {
    if (!sucess) return;
    let resData = sucess;

    if (resData?.profileDetails) {
      resData = resData.profileDetails;
    }
    if (resData?.data !== undefined) {
      resData = resData.data;
    }
    if (resData?.data !== undefined) {
      resData = resData.data;
    }
    if (Array.isArray(resData)) {
      resData = resData[0] || {};
    }

    if (resData && typeof resData === "object" && Object.keys(resData).length > 0) {
      const clonedProfile = JSON.parse(JSON.stringify(resData));

      // Normalize Affiliations
      let affiliationsList = [];
      let affType =
        clonedProfile?.affiliation?.affiliation_type ||
        clonedProfile?.affiliation_type ||
        clonedProfile?.affiliationType ||
        "University";

      if (
        Array.isArray(clonedProfile?.affiliation?.affiliations) &&
        clonedProfile.affiliation.affiliations.length > 0
      ) {
        affiliationsList = clonedProfile.affiliation.affiliations;
      } else if (
        Array.isArray(clonedProfile?.affiliations) &&
        clonedProfile.affiliations.length > 0
      ) {
        affiliationsList = clonedProfile.affiliations;
      } else if (
        Array.isArray(clonedProfile?.affiliation) &&
        clonedProfile.affiliation.length > 0
      ) {
        affiliationsList = clonedProfile.affiliation;
      } else if (
        Array.isArray(clonedProfile?.workSection) &&
        clonedProfile.workSection.length > 0
      ) {
        affiliationsList = clonedProfile.workSection.map((w, idx) => ({
          order: idx + 1,
          name: w.universitySchoolCompany || w.name,
          url: w.URL || w.url,
          department: w.affiliatedDepartment || w.department,
          subject: w.subject,
          specialization: w.specialization,
          state: w.state,
          city: w.city,
          pincode: w.pincode,
          affiliationType: w.affiliationType || affType,
        }));
        if (clonedProfile?.workSection[0]?.affiliationType) {
          affType = clonedProfile.workSection[0].affiliationType;
        }
      }

      affiliationsList.forEach((aff, idx) => {
        aff.order = idx + 1;
        if (aff.url || aff.URL) {
          aff.verified = true;
        }
      });

      // Normalize Education
      const educationObj =
        clonedProfile?.Education ||
        clonedProfile?.education ||
        clonedProfile?.educationSection ||
        {};

      // Normalize Subject of Interest
      const soiList =
        clonedProfile?.subjectOfInterest ||
        clonedProfile?.subject_of_interest ||
        clonedProfile?.subjectOfIntrestSection ||
        [];

      setPreviewProfile((prev) => ({
        ...prev,
        ...clonedProfile,
        affiliation: {
          affiliation_type: affType,
          affiliations: affiliationsList,
        },
        Education: educationObj,
        subjectOfInterest: soiList,
        workType:
          clonedProfile?.workType ||
          clonedProfile?.work_type ||
          prev?.workType ||
          location?.state?.profileDetails?.workType ||
          "Academic",
        gender:
          clonedProfile?.gender ||
          prev?.gender ||
          location?.state?.profileDetails?.gender ||
          localStorage.getItem("user_gender") ||
          "",
      }));
    }
  };

  const fetchdata = async () => {
    const token = tokenFromStorage || userLoginDetails?.token || "";
    let userId = user?._id || id;
    if (!userId && token) {
      try {
        const decoded = jwt_decode(token);
        userId = decoded?.id || decoded?._id;
      } catch (e) {
        console.error(e);
      }
    }
    const params = { id: userId };
    const headers = { Authorization: `Bearer ${token}` };
    return getProfileDetails(headers, params);
  };

  const { refetch } = FetchProfileDetails(fetchdata, sucessHandler, setError, error);

  // Force refetch from server on mount to get the latest saved data
  useEffect(() => {
    refetch();
  }, []);

  const publishSuccessHandler = (_success) => {
    if (_success?.data?.success) {
      setShowFeedbackModal({
        ...initialState,
        congratsPreview: true,
      });
    } else {
      toast.error(_success?.data?.error);
    }
    dispatch({
      type: "SET_LOADER",
      payload: false,
    });
  };

  const { mutate: PublishPreviewProfile } = setUpProfile(publishSuccessHandler);

  const handlePublishPreviewProfile = () => {
    const headers = { Authorization: `Bearer ${tokenFromStorage}` };
    dispatch({
      type: "SET_LOADER",
      payload: true,
    });
    const queryParams = {
      params: { id: id || user?._id },
      data: { publishProfile: true, isSetupProfile: true },
      headers: { ...headers, "Content-Type": "application/json" },
    };

    PublishPreviewProfile(queryParams);
  };

  const handleGoBack = (e) => {
    if (e) e.preventDefault();
    navigate("/personaldetails", {
      state: { activeTab: "professional", profileDetails: PreviewProfile },
    });
  };

  const renderHeading = (value, index) => {
    const idxOrder = typeof index === "number" ? index + 1 : 1;
    const order = (value?.order === 2 || value?.order === 3) ? value.order : idxOrder;
    if (order === 2) {
      return "Secondary Affiliation";
    } else if (order === 3) {
      return "Tertiary Affiliation";
    }
    return "Primary Affiliation";
  };

  const isProfilePublishable = PreviewProfile?.email
    ? isPublishable({
        ...PreviewProfile,
        affiliations: PreviewProfile.affiliation?.affiliations,
        subjects: PreviewProfile?.Education,
        educationSection: PreviewProfile.Education,
      })
    : false;

  const handleFeedbackModalStat = async (data, refetchData = false) => {
    setShowFeedbackModal(data);
    if (refetchData) {
      const response = await fetchdata();
      if (response?.status === 200) {
        sucessHandler(response);
        setPreviewProfile((prev) => ({ ...prev, feedbackDone: refetchData }));
      }
    }
  };

  const handleGetSpecialization = async () => {
    const headers = { Authorization: `Bearer ${tokenFromStorage}` };
    const userId = id || user?._id;
    const params = { userId };
    dispatch({ type: "SET_LOADER", payload: true });
    const addResp = await getOtherSpecialization(headers, params);
    dispatch({ type: "SET_LOADER", payload: false });
    if (addResp?.data?.success) {
      dispatch({
        type: GET_OTHER_SUBJECT,
        payload: addResp?.data?.data,
      });
      getSubjectStatus(addResp?.data?.data);
    }
  };

  const getSubjectStatus = (anotherSubject) => {
    anotherSubject &&
      anotherSubject?.filter((sub) => {
        if (sub?.status === "Pending") {
          dispatch({
            type: SAVE_SUBJECT_STATUS,
            payload: true,
          });
        }
        return null;
      });
  };

  useEffect(() => {
    const initialData = location?.state?.profileDetails || reduxProfileUser;
    if (initialData && Object.keys(initialData).length > 0) {
      sucessHandler(initialData);
    }

    fetchdata().then((res) => {
      if (res) {
        sucessHandler(res);
      }
    });

    handleGetSpecialization();
    getSubjectStatus();
  }, [location?.state?.profileDetails]);

  const getTitleDisplay = (profileData) => {
    return profileData?.title || location?.state?.profileDetails?.title || "";
  };

  const getFirstNameDisplay = (profileData) => {
    if (profileData?.firstName) return profileData.firstName;
    const name =
      profileData?.fullName ||
      profileData?.name ||
      location?.state?.profileDetails?.fullName ||
      location?.state?.profileDetails?.name ||
      "";
    if (!name) return "";
    return name.trim().split(" ")[0] || "";
  };

  const getLastNameDisplay = (profileData) => {
    if (profileData?.lastName) return profileData.lastName;
    const name =
      profileData?.fullName ||
      profileData?.name ||
      location?.state?.profileDetails?.fullName ||
      location?.state?.profileDetails?.name ||
      "";
    if (!name) return "";
    const parts = name.trim().split(" ");
    return parts.length > 1 ? parts.slice(1).join(" ") : "";
  };

  const getGenderDisplay = (profileData) => {
    const g =
      profileData?.gender ||
      location?.state?.profileDetails?.gender ||
      localStorage.getItem("user_gender");
    if (g === "GenderFluid") return "Gender Fluid";
    if (g === "Other") return "Others";
    return g || "";
  };

  const getLocationDisplay = (profileData) => {
    const aff = profileData?.affiliation?.affiliations?.[0];
    if (aff?.city && aff?.state) return `${aff.city}, ${aff.state}`;
    if (aff?.city) return aff.city;
    if (aff?.state) return aff.state;
    if (profileData?.city) return profileData.city;
    if (profileData?.state) return profileData.state;
    if (profileData?.nationality === "withInIndia") return "Within India";
    if (profileData?.nationality === "outSideIndia") return "Outside India";
    return profileData?.nationality || "";
  };

  const getWorkTypeDisplay = (profileData) => {
    return (
      profileData?.workType ||
      profileData?.work_type ||
      location?.state?.profileDetails?.workType ||
      localStorage.getItem("user_workType") ||
      "Academic"
    );
  };

  const getQualificationDisplay = (education) => {
    if (!education) return "";
    const qual = education.qualification || education;
    if (typeof qual === "string") return qual;
    if (qual?.qualification) return qual.qualification;
    if (qual?.name) return qual.name;
    return "";
  };

  const getDisciplineDisplay = (record) => {
    if (!record) return "";
    const sub = record.subject || record.interestedsubject || record.discipline;
    if (typeof sub === "string") return sub;
    if (sub?.subjectName) return sub.subjectName;
    if (sub?.name) return sub.name;
    if (sub?.subject) return typeof sub.subject === "string" ? sub.subject : sub.subject?.subjectName || sub.subject?.name || "";
    return "";
  };

  const getSubjectSpecializationDisplay = (record) => {
    if (!record) return "";
    const specs =
      record.specialization ||
      record.subjectSpecialization ||
      record.specializations;
    if (!specs) return "";
    if (typeof specs === "string") return specs;
    if (Array.isArray(specs)) {
      if (specs.length === 0) return "";
      const firstSpec =
        typeof specs[0] === "string"
          ? specs[0]
          : specs[0]?.specialization ||
            specs[0]?.name ||
            specs[0]?.subjectName ||
            "";
      if (specs.length === 1) return firstSpec;
      return `${firstSpec} +${specs.length - 1}`;
    }
    if (typeof specs === "object") {
      return specs.specialization || specs.name || "";
    }
    return "";
  };

  const getAffiliationName = (aff) => {
    return aff?.name || aff?.universitySchoolCompany || aff?.university_school_company || "";
  };

  const getAffiliationUrl = (aff) => {
    return aff?.url || aff?.URL || "";
  };

  const getAffiliationDepartment = (aff) => {
    return aff?.department || aff?.affiliatedDepartment || aff?.affiliated_department || "";
  };

  const getAffiliationDiscipline = (aff) => {
    if (!aff) return "";
    const sub = aff?.subject;
    if (typeof sub === "string") return sub;
    if (sub?.subjectName) return sub.subjectName;
    if (sub?.name) return sub.name;
    return "";
  };

  return (
    <div className="preview-profile centerSection">
      {showFeedbackModal && (
        <FeedbackFlow
          handleModalClose={handleFeedbackModalStat}
          code={PreviewProfile.promoCode}
          modalStat={showFeedbackModal}
        />
      )}

      <div className="pd-card-wrapper py-4">
        {error?.apiErrors && (
          <div className="label-error text-center mb-3">{error?.apiErrors}</div>
        )}

        <div className="pd-preview-card">
          <h1 className="preview-card-title">Profile Details</h1>

          {/* Personal Details Section */}
          <div className="preview-section mb-4">
            <h2 className="preview-section-heading">Personal Details</h2>

            {/* Profile Picture Row */}
            <div className="preview-avatar-row mb-4">
              <div className="profile-upload-avatar">
                {profilePic ? (
                  <img src={profilePic} alt="Profile" />
                ) : (
                  <i className="fa fa-camera"></i>
                )}
              </div>
              <span className="profile-picture-label">Profile Picture</span>
            </div>

            {/* Grid for Personal Details Fields */}
            <div className="row">
              {/* Title, First Name, Last Name */}
              <div className="col-lg-3 col-md-3 col-12">
                <div className="floating-field-box">
                  <label>Title</label>
                  <div className="floating-field-input select-box">
                    <span>{getTitleDisplay(PreviewProfile) || "Mr"}</span>
                    <img
                      src={selectArrow}
                      alt="v"
                      className="select-arrow-icon"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-4.5 col-md-4.5 col-12 style-fn-col">
                <div className="floating-field-box">
                  <label>First Name</label>
                  <div className="floating-field-input icon-input">
                    <img src={userIcon} alt="user" className="field-pre-icon" />
                    <span>{getFirstNameDisplay(PreviewProfile)}</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-4.5 col-md-4.5 col-12 style-ln-col">
                <div className="floating-field-box">
                  <label>Last Name</label>
                  <div className="floating-field-input icon-input">
                    <img src={userIcon} alt="user" className="field-pre-icon" />
                    <span>{getLastNameDisplay(PreviewProfile)}</span>
                  </div>
                </div>
              </div>

              {/* Email ID, Mobile Number */}
              <div className="col-lg-6 col-md-6 col-12">
                <div className="floating-field-box">
                  <label>Email ID</label>
                  <div className="floating-field-input icon-input">
                    <img
                      src={emailIcon}
                      alt="email"
                      className="field-pre-icon"
                    />
                    <span>{PreviewProfile?.email}</span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <div className="floating-field-box">
                  <label>Mobile Number</label>
                  <div className="floating-field-input icon-input">
                    <img
                      src={active_phone}
                      alt="phone"
                      className="field-pre-icon"
                    />
                    <span>{PreviewProfile?.phoneNumber}</span>
                  </div>
                </div>
              </div>

              {/* Gender, Location */}
              <div className="col-lg-6 col-md-6 col-12">
                <div className="floating-field-box">
                  <label>Gender</label>
                  <div className="floating-field-input select-box">
                    <span>{getGenderDisplay(PreviewProfile)}</span>
                    <img
                      src={selectArrow}
                      alt="v"
                      className="select-arrow-icon"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <div className="floating-field-box">
                  <label>Location</label>
                  <div className="floating-field-input select-box">
                    <span>{getLocationDisplay(PreviewProfile)}</span>
                    <img
                      src={selectArrow}
                      alt="v"
                      className="select-arrow-icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Professional Details Section */}
          <div className="preview-section mt-4">
            <h2 className="preview-section-heading">Professional Details</h2>

            {/* Work Type */}
            <div className="floating-field-box mb-4">
              <label>Work Type</label>
              <div className="floating-field-input">
                <span>{getWorkTypeDisplay(PreviewProfile)}</span>
              </div>
            </div>

            {/* Primary Affiliation */}
            {PreviewProfile?.affiliation?.affiliations &&
            PreviewProfile.affiliation.affiliations.length > 0 ? (
              PreviewProfile.affiliation.affiliations.map((aff, index) => {
                const affType =
                  PreviewProfile?.affiliation?.affiliation_type || "University";
                return (
                  <div className="preview-fieldset-card mb-4" key={index}>
                    <span className="fieldset-card-label">
                      {renderHeading(aff, index)}
                    </span>

                    {/* Radio / Checkboxes for Affiliation Types */}
                    <div className="affiliation-checkbox-tags mb-3">
                      {["University", "Institute", "Company", "Hospital"].map(
                        (type) => (
                          <label className="checkbox-tag-item" key={type}>
                            <input
                              type="checkbox"
                              checked={
                                affType.toLowerCase() === type.toLowerCase()
                              }
                              readOnly
                            />
                            <span className="custom-checkbox-box"></span>
                            <span className="tag-label">{type}</span>
                          </label>
                        )
                      )}
                    </div>

                    {/* Name of Affiliation */}
                    <div className="floating-field-box mb-3">
                      <div className="floating-field-input">
                        <span>{getAffiliationName(aff)}</span>
                      </div>
                    </div>

                    {/* URL of Affiliation */}
                    <div className="floating-field-box mb-3">
                      <div className="floating-field-input icon-input">
                        <img
                          src={active_link}
                          alt="link"
                          className="field-pre-icon"
                        />
                        <span className="link-text-color">
                          {getAffiliationUrl(aff)}
                        </span>
                      </div>
                    </div>

                    {/* Grid 2 Columns for Affiliation details */}
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>{getAffiliationDepartment(aff)}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>{getAffiliationDiscipline(aff)}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>
                              {getSubjectSpecializationDisplay(aff)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>{aff?.state || ""}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>{aff?.city || ""}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="floating-field-box">
                          <div className="floating-field-input">
                            <span>
                              {aff?.pincode && aff?.pincode !== 0
                                ? String(aff?.pincode)
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="preview-fieldset-card mb-4">
                <span className="fieldset-card-label">Primary Affiliation</span>
                <div className="affiliation-checkbox-tags mb-3">
                  {["University", "Institute", "Company", "Hospital"].map(
                    (type, idx) => (
                      <label className="checkbox-tag-item" key={type}>
                        <input type="checkbox" checked={idx === 0} readOnly />
                        <span className="custom-checkbox-box"></span>
                        <span className="tag-label">{type}</span>
                      </label>
                    )
                  )}
                </div>
              </div>
            )}

            {/* Education Fieldset */}
            <div className="preview-fieldset-card mb-4">
              <span className="fieldset-card-label">Education</span>
              <p className="education-subtext-italic">Highest degree earned</p>

              <div className="floating-field-box mb-3">
                <div className="floating-field-input">
                  <span>
                    {getQualificationDisplay(PreviewProfile?.Education)}
                  </span>
                </div>
              </div>

              <div className="floating-field-box mb-3">
                <div className="floating-field-input">
                  <span>
                    {getDisciplineDisplay(PreviewProfile?.Education)}
                  </span>
                </div>
              </div>

              <div className="floating-field-box mb-3">
                <div className="floating-field-input">
                  <span>
                    {getSubjectSpecializationDisplay(PreviewProfile?.Education)}
                  </span>
                </div>
              </div>
            </div>

            {/* Subject of Interest Fieldset */}
            <div className="preview-fieldset-card mb-4">
              <span className="fieldset-card-label">Subject of Interest</span>

              {PreviewProfile?.subjectOfInterest &&
              PreviewProfile.subjectOfInterest.length > 0 ? (
                PreviewProfile.subjectOfInterest.map((val, ind) => (
                  <div key={ind} className="soi-item-block mb-2">
                    <div className="floating-field-box mb-3">
                      <div className="floating-field-input">
                        <span>{getDisciplineDisplay(val)}</span>
                      </div>
                    </div>

                    <div className="floating-field-box mb-3">
                      <div className="floating-field-input">
                        <span>
                          {getSubjectSpecializationDisplay(val)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="floating-field-box">
                  <div className="floating-field-input">
                    <span>None</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="preview-actions-bar mt-4">
          <button
            type="button"
            className="btn-back-teal-outline"
            onClick={(e) => handleGoBack(e)}
          >
            BACK
          </button>
          <button
            type="button"
            className="btn-publish-teal-filled"
            disabled={!isProfilePublishable}
            onClick={(e) => {
              PreviewProfile?.nationality === "outSideIndia"
                ? handlePublishPreviewProfile()
                : handleFeedback(e);
            }}
          >
            PUBLISH PROFILE
          </button>
        </div>
      </div>

      <UpArrowQuestion />
      <BeforePublishModal
        showAccept={showAccept}
        setShowAccept={setShowAccept}
        title={"All Good things take time"}
        body={`<div class="text-center"><p class="font18">Your profile will be published after we approve the subject.</p>
          <p class="mt-3 font18">Thank you for your patience</p>
        </div>`}
        btnTxt={"Okay"}
      />
    </div>
  );
};

export default PreviewProfile;
